import { getAxiosInstance } from "../../../api";

export const bulkUploadVideos = async (formData) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post("admin/video/bulk-upload", formData);
    return response;
  } catch (error) {
    return error.response?.data ?? { status_code: 500, message: error.message };
  }
};

export const downloadBulkUploadSample = async () => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get("admin/video/bulk-upload/sample", {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error.response ?? { status: 500 };
  }
};
